module.exports = __webpack_public_path__ + "assets/6603b0d709e0ef980a7eee460ed21b48.mp3";